import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdNotificationsOutline } from "react-icons/io";
import avatar from "assets/img/avatars/avatar4.png";
import { useAuth } from "context/AuthContext";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const { name, email, role, logout } = useAuth();

  const roleName =
    role === "SA" ? "Super Admin" : role === "A" ? "Admin" : role === "R" ? "Runner Boy" : role;

  return (
    <nav className="sticky top-2 sm:top-4 z-40 flex flex-row flex-wrap items-center justify-between gap-2 rounded-xl bg-white/10 p-2 sm:p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-0 sm:ml-1 min-w-0 flex-1">
       
        <p className="min-w-0 text-lg sm:text-2xl md:text-3xl capitalize text-navy-700 dark:text-white truncate">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative flex h-10 sm:h-12 min-w-0 max-w-full flex-shrink-0 items-center justify-end gap-1 sm:gap-2 rounded-full bg-white px-2 py-1.5 sm:py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0">
        <div className="hidden sm:flex flex-1 min-w-0 max-w-[180px] md:max-w-[225px] h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
           <p className="pl-2 sm:pl-3 pr-1 sm:pr-2 text-sm sm:text-base text-blue-700 dark:text-blue-300 shrink-0">
  {name || email || "User"}
</p>


          {/*<input
            type="text"
            placeholder="Search..."
            className="block h-full w-full min-w-0 rounded-full bg-lightPrimary text-xs sm:text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
          /> */}
        </div>
        <span
          className="flex cursor-pointer p-1.5 sm:p-0 text-gray-600 dark:text-white xl:hidden shrink-0"
          onClick={onOpenSidenav}
          aria-label="Open menu"
        >
          <FiAlignJustify className="h-5 w-5 sm:h-6 sm:w-6" />
        </span>

        {/* Notifications 
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notifications
                </p>
              </div>
              <p className="text-sm text-gray-500 dark:text-gray-300">
                No new notifications
              </p>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        {/* Dark mode toggle 
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>*/}

        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-8 w-8 sm:h-10 sm:w-10 rounded-full object-cover shrink-0"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAMAAABC4vDmAAAARVBMVEX6+vqPj4/////l5eWMjIyIiIj19fWCgoKVlZXGxsaYmJiSkpKxsbG3t7fp6eny8vKkpKS+vr7Nzc2qqqrf39/X19eenp7INw94AAAC6UlEQVR4nO2b27KrIAxAMXLxBqJo//9TD9o9s7trVawYPDNZD20f14RbSChjBEEQBEEQBEEQBEEQxE2BiecnpHZ5AtAOpbZVXVdW94O8gRdA3hSZEJxnGedCZJU2ibUARqu8zitc2TGlFRjL35RmLe7aZFrQiw9KT61UwQItPitNiC6JFbgNJ2+lU1g1m05JrKDbcfJWPbIVDGrPKctUjmslq32njD9QnQIGbx7AEjNUMmDw5lghSoFe2TRThqoNmVFzpPBmFYxBM2q2GrBCtXm+pBo/CFWaxg9tUgWuvTlUSFKQH5BSLZJU+DzHO2p8bndg+JCWH5RHpJBS0EORUlhSd5xTzNxw9d1yn2JQBzvh7ej3PPvGwHTKRypHcrpnPhWaoiPfsoJzdDyl8NsM7nVUPgLmOreYSqE3ZIN9b99PFbAShFerZidWKkWFCrZrQYmqZkxvxEqhlhFegLFeWYOiQLuELq3MomA9wVWTrjo8aeWOv00twR1ysWxpxQYtlOA/CMW7nKVvhDAA02tnPU737Q1aMz9MJlI+vwnifwegNfkXmAvbpTC6IvzK90JdNBcdOytnShhcXdKXhCH7WmnWKi7IQ9tzTt6qil7rAHfSyZ/UTeRQwXDaycfKRJbqYkjFzkZtDKkmrpOsYkhFvpwGdUJJapIq7jh8IQWNXSkXV4qd3zvjr77grvGmVOSbPJQxpCLX0CCPIRX9RP4qu/tLFTt3OdRP+8wFFVBzevzq+L2j03lC9BxhQp6T4ll8pYO9xyUXNZMPNK8+OF1VAgX7tVX0/PwXuf1gccvpKiW2+4xy1enih4zl2iPYdXjsM28BDI8Dbe0JZa+vywIri/BocV70KHVZkGURVurgqiolWmebjbbeCxcXtR1Rq9cAee+m+vnKoAnFXZ/gCT8wmXeuKnxIxG9x3//MiocrDUtV4p/+/GGGsS+1bpyn0V3Zj3nLkv8rBN5Jq0MQBEEQBEEQBEEQBEGs8Q9UMiC2Cz0iwAAAAABJRU5ErkJggg==" data-csiid="AAGXad7kIdy3juMPiPTYyAs_13" data-atf="1"
              alt="Profile"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex flex-col">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {name || email || "User"}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-300">
                    {roleName}
                  </p>
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20" />

              <div className="flex flex-col p-4">
                <Link
                  to="/admin/profile"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </Link>
                <button
                  onClick={logout}
                  className="mt-3 text-left text-sm font-medium text-red-500 hover:text-red-600 transition duration-150 ease-out hover:ease-in"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
